import { DateTime } from "luxon";
import { toStringDate } from "../utils/ToStringDate.ts";
import type { KlusModel } from "./KlusModel.ts";

export class CreateKlusModel {
  id?: number;
  scenarioId: string;
  klusSoort: string;
  beginDatum: string;
  beginTijd: string;
  eindDatum: string;
  eindTijd: string;
  dienstregelpuntStart: string;
  spoorStart?: string;
  dienstregelpuntEind?: string;
  spoorEind?: string;
  knooppuntNaam: string;
  dienst?: string;
  toelichting?: string;
  bewegingsCode?: string;
  klusActieId?: string;
  relatieActieId?: string;

  constructor(data?: Partial<CreateKlusModel> | KlusModel) {
    this.klusSoort = data?.klusSoort ?? "";
    this.id = data?.id;
    this.scenarioId = data?.scenarioId ?? "";
    if (isKlusModel(data)) {
      this.beginDatum = DateTime.fromISO(toStringDate(data.beginDatumtijd)).toFormat("yyyy-MM-dd");
      this.beginTijd = DateTime.fromISO(toStringDate(data.beginDatumtijd)).toFormat("HH:mm");
      this.eindDatum = DateTime.fromISO(toStringDate(data.eindDatumtijd)).toFormat("yyyy-MM-dd");
      this.eindTijd = DateTime.fromISO(toStringDate(data.eindDatumtijd)).toFormat("HH:mm");
    } else {
      const createKlusData = data as CreateKlusModel;
      this.beginDatum = createKlusData?.beginDatum ?? "";
      this.beginTijd = createKlusData?.beginTijd ?? "";
      this.eindDatum = createKlusData?.eindDatum ?? "";
      this.eindTijd = createKlusData?.eindTijd ?? "";
    }
    this.dienstregelpuntStart = data?.dienstregelpuntStart ?? "";
    if (data?.spoorStart) {
      this.spoorStart = data.spoorStart;
    }
    this.dienstregelpuntEind = data?.dienstregelpuntEind ?? "";
    if (data?.spoorEind) {
      this.spoorEind = data.spoorEind;
    }
    this.knooppuntNaam = data?.knooppuntNaam ?? "";
    if (data?.dienst) {
      this.dienst = data.dienst;
    }
    if (data?.toelichting) {
      this.toelichting = data.toelichting;
    }
    if (data?.bewegingsCode) {
      this.bewegingsCode = data.bewegingsCode;
    }
    if (data?.klusActieId) {
      this.klusActieId = data.klusActieId;
    }
    if (data?.relatieActieId) {
      this.relatieActieId = data.relatieActieId;
    }
  }
}

function isKlusModel(
  data: Partial<CreateKlusModel> | Partial<KlusModel> | undefined,
): data is KlusModel {
  return data != null && "beginDatumtijd" in data && data.beginDatumtijd != null;
}

export function buildKlusModel(data: CreateKlusModel): KlusModel {
  const begin = DateTime.fromFormat(`${data.beginDatum} ${data.beginTijd}`, "yyyy-MM-dd HH:mm");
  const eind = DateTime.fromFormat(`${data.eindDatum} ${data.eindTijd}`, "yyyy-MM-dd HH:mm");
  return {
    id: data.id ?? -1,
    scenarioId: data.scenarioId,
    klusSoort: data.klusSoort,
    beginDatumtijd: begin.isValid ? begin : DateTime.now(),
    eindDatumtijd: eind.isValid ? eind : DateTime.now(),
    dienstregelpuntStart: data.dienstregelpuntStart,
    spoorStart: data.spoorStart ?? "",
    dienstregelpuntEind: data.dienstregelpuntEind ?? "",
    spoorEind: data.spoorEind ?? "",
    knooppuntNaam: data.knooppuntNaam,
    dienst: data.dienst ?? "",
    toelichting: data.toelichting ?? "",
    bewegingsCode: data.bewegingsCode ?? "",
    klusActieId: data.klusActieId ?? "",
    relatieActieId: data.relatieActieId ?? "",
  };
}
